/**
 * `multipart/form-data` non ha array: un solo campo `warningDays=14` arriva come
 * stringa, due campi arrivano come array di stringhe. Normalizza tutto in un
 * array di numeri; un valore non numerico diventa `NaN` e lo scarta `@IsInt`.
 */
export function toWarningDaysArray(value: unknown): unknown {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }
  const rawItems: unknown[] = Array.isArray(value) ? value : String(value).split(',');
  return rawItems.map((item) => (typeof item === 'number' ? item : Number(String(item).trim())));
}
